var _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _g3, _path58, _g4, _path59, _g5, _path60, _g6, _path61, _g7, _path62, _g8, _path63, _g9, _path64, _g10, _path65, _g11, _path66, _g12, _path67, _g13, _path68, _g14, _path69, _g15, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _g16, _path88, _g17, _path89, _g18, _path90, _g19, _path91, _g20, _path92, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBfse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 300,
    viewBox: "0 0 380 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_483)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 112,
    width: 33,
    height: 77
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.008 112.374L69.1182 126.435L69.1139 126.42L60 123.975L76.6887 185.927L85.2958 188.433L92.5671 181.168L78.3423 128.91L85.4618 121.846L92.5098 114.888L83.0381 112.357L83.0352 112.347L83.028 112.353L83.0008 112.346L83.008 112.374Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.3504 104.149L40.8358 117.527L62.2115 196.639L111.726 183.261L90.3504 104.149Z",
    fill: "url(#paint0_linear_338_483)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 110,
    width: 28,
    height: 50
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0903 131.503L95.532 159.602L115.939 139.082L113.481 129.808L104.098 127.328L111 120.44L108.491 110.984L88.0903 131.503Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.044 103.976L75.8458 114.297L89.9833 166.62L128.181 156.299L114.044 103.976Z",
    fill: "url(#paint1_linear_338_483)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.579 155.847H209.682V155.48H211.862V155.847H210.97V159.532H210.579V155.847Z",
    fill: "#1A66AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M286.701 155.837H285.804V155.471H287.984V155.837H287.092V159.522H286.701V155.837Z",
    fill: "#1A66AB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.357 155.48H212.727V156.921H212.737C212.848 156.74 213.133 156.461 213.624 156.461C213.978 156.461 214.273 156.554 214.538 156.828C214.754 157.047 214.896 157.39 214.896 157.884V159.532H214.526V157.884C214.526 157.496 214.41 157.221 214.253 157.062C214.052 156.861 213.788 156.806 213.624 156.806C213.461 156.806 213.196 156.861 212.996 157.062C212.837 157.221 212.721 157.496 212.727 157.884V159.532H212.357V155.48Z",
    fill: "#1A66AB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.068 158.173C216.095 158.758 216.622 159.256 217.188 159.256C217.716 159.245 218.09 158.923 218.223 158.549H218.614C218.413 159.146 217.859 159.6 217.193 159.6C216.386 159.6 215.69 158.921 215.69 158.035C215.69 157.149 216.35 156.475 217.189 156.459C217.822 156.465 218.271 156.853 218.478 157.225C218.672 157.548 218.715 157.882 218.7 158.173H216.071H216.068ZM218.322 157.828C218.206 157.122 217.652 156.804 217.192 156.804C216.732 156.804 216.174 157.122 216.068 157.828H218.322Z",
    fill: "#1A66AB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M221.561 155.477H221.192V159.53H221.561V155.477Z",
    fill: "#1A66AB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M222.485 156.535H222.854V156.919H222.864C222.974 156.738 223.261 156.459 223.752 156.459C224.105 156.459 224.4 156.552 224.665 156.825C224.881 157.045 225.025 157.39 225.025 157.883V159.531H224.654V157.883C224.654 157.494 224.538 157.221 224.379 157.062C224.178 156.86 223.915 156.804 223.752 156.804C223.589 156.804 223.324 156.858 223.123 157.062C222.964 157.221 222.848 157.494 222.854 157.883V159.531H222.485V156.536V156.535Z",
    fill: "#1A66AB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M226.279 156.882H225.672V156.535H226.279V155.479H226.648V156.535H227.34V156.882H226.648V159.53H226.279V156.882Z",
    fill: "#1A66AB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M228.126 158.173C228.153 158.758 228.68 159.256 229.245 159.256C229.773 159.245 230.147 158.923 230.28 158.549H230.671C230.471 159.146 229.917 159.6 229.251 159.6C228.443 159.6 227.748 158.921 227.748 158.035C227.748 157.149 228.408 156.475 229.246 156.459C229.879 156.465 230.329 156.853 230.535 157.225C230.73 157.548 230.773 157.882 230.757 158.173H228.128H228.126ZM230.379 157.828C230.263 157.122 229.709 156.804 229.249 156.804C228.79 156.804 228.231 157.122 228.126 157.828H230.379Z",
    fill: "#1A66AB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M231.556 156.535H231.925V156.969H231.935C232.11 156.546 232.438 156.482 232.748 156.459V156.864C232.489 156.887 232.267 156.986 232.125 157.16C231.998 157.324 231.925 157.538 231.925 157.779V159.531H231.556V156.536V156.535Z",
    fill: "#1A66AB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M233.381 156.535H233.75V156.919H233.76C233.871 156.738 234.157 156.459 234.648 156.459C235.002 156.459 235.297 156.552 235.561 156.825C235.778 157.045 235.921 157.39 235.921 157.883V159.531H235.55V157.883C235.55 157.494 235.434 157.221 235.277 157.062C235.076 156.86 234.811 156.804 234.648 156.804C234.485 156.804 234.22 156.858 234.02 157.062C233.861 157.221 233.745 157.494 233.75 157.883V159.531H233.381V156.536V156.535Z",
    fill: "#1A66AB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M239.773 159.53H239.404V159.004H239.394C239.078 159.497 238.571 159.601 238.27 159.601C237.363 159.601 236.718 158.883 236.718 158.024C236.718 157.225 237.325 156.459 238.27 156.459C238.582 156.459 239.088 156.563 239.394 157.062H239.404V156.536H239.773V159.531V159.53ZM238.269 159.256C238.892 159.256 239.424 158.737 239.424 158.035C239.424 157.378 238.933 156.804 238.269 156.804C237.604 156.804 237.086 157.279 237.086 158.041C237.086 158.71 237.56 159.256 238.269 159.256Z",
    fill: "#1A66AB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M240.992 156.882H240.383V156.535H240.992V155.479H241.361V156.535H242.053V156.882H241.361V159.53H240.992V156.882Z",
    fill: "#1A66AB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M242.681 155.48H243.05V156.171H242.681V155.48ZM242.681 156.536H243.05V159.531H242.681V156.536Z",
    fill: "#1A66AB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M245.355 156.459C246.211 156.459 246.87 157.209 246.87 158.031C246.87 158.853 246.222 159.603 245.355 159.603C244.489 159.603 243.851 158.863 243.851 158.054C243.851 157.106 244.595 156.46 245.355 156.46M245.361 159.258C245.921 159.258 246.502 158.798 246.502 158.015C246.502 157.232 245.858 156.805 245.361 156.805C244.833 156.805 244.221 157.254 244.221 158.048C244.221 158.744 244.764 159.258 245.361 159.258Z",
    fill: "#1A66AB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M247.666 156.535H248.035V156.919H248.045C248.156 156.738 248.442 156.459 248.933 156.459C249.287 156.459 249.582 156.552 249.846 156.825C250.063 157.045 250.206 157.39 250.206 157.883V159.531H249.835V157.883C249.835 157.494 249.719 157.221 249.562 157.062C249.361 156.86 249.096 156.804 248.933 156.804C248.77 156.804 248.505 156.858 248.305 157.062C248.146 157.221 248.03 157.494 248.035 157.883V159.531H247.666V156.536V156.535Z",
    fill: "#1A66AB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M254.057 159.53H253.687V159.004H253.677C253.361 159.497 252.854 159.601 252.554 159.601C251.646 159.601 251.002 158.883 251.002 158.024C251.002 157.225 251.609 156.459 252.554 156.459C252.866 156.459 253.371 156.563 253.677 157.062H253.687V156.536H254.057V159.531V159.53ZM252.552 159.256C253.175 159.256 253.708 158.737 253.708 158.035C253.708 157.378 253.216 156.804 252.552 156.804C251.888 156.804 251.37 157.279 251.37 158.041C251.37 158.71 251.844 159.256 252.552 159.256Z",
    fill: "#1A66AB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M255.334 155.48H254.965V159.532H255.334V155.48Z",
    fill: "#1A66AB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M258.631 159.611C258.323 159.611 258.014 159.483 257.806 159.27C257.59 159.048 257.481 158.74 257.49 158.375L257.937 158.422C257.911 158.686 257.981 158.905 258.126 159.051C258.292 159.22 258.515 159.244 258.632 159.244C259.115 159.244 259.403 158.958 259.403 158.477C259.403 157.954 258.997 157.791 258.703 157.673L258.601 157.632C258.203 157.492 257.603 157.28 257.603 156.56C257.603 156.029 257.967 155.49 258.661 155.49C258.932 155.49 259.186 155.596 259.374 155.785C259.567 155.98 259.672 156.246 259.668 156.535L259.221 156.488C259.234 156.059 258.933 155.857 258.64 155.857C258.227 155.857 258.004 156.192 258.004 156.508C258.004 156.975 258.459 157.129 258.73 157.221C259.106 157.349 259.804 157.586 259.804 158.418C259.808 158.78 259.698 159.084 259.489 159.296C259.284 159.502 258.989 159.611 258.632 159.611",
    fill: "#1A66AB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M262.748 159.53H262.4V159.065H262.39C262.285 159.29 262.005 159.602 261.467 159.602C260.896 159.602 260.601 159.317 260.473 159.154C260.267 158.89 260.22 158.508 260.22 158.19V156.537H260.589V158.184C260.589 158.562 260.668 158.809 260.796 158.973C260.996 159.208 261.265 159.258 261.466 159.258C261.666 159.258 261.892 159.208 262.077 159.018C262.246 158.842 262.378 158.645 262.378 158.119V156.535H262.747V159.53H262.748Z",
    fill: "#1A66AB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M263.688 156.536H264.057V156.881L264.047 156.87V156.881H264.057C264.22 156.586 264.574 156.459 264.843 156.459C265.086 156.459 265.597 156.574 265.814 157.033C266.031 156.574 266.542 156.459 266.786 156.459C267.23 156.459 267.941 156.732 267.941 157.752V159.531H267.572V157.796C267.572 157.468 267.513 157.309 267.44 157.172C267.32 156.959 267.096 156.804 266.786 156.804C266.475 156.804 266.253 156.957 266.131 157.172C266.058 157.309 266 157.468 266 157.796V159.531H265.63V157.796C265.63 157.468 265.572 157.309 265.499 157.172C265.377 156.959 265.155 156.804 264.844 156.804C264.534 156.804 264.312 156.957 264.19 157.172C264.116 157.309 264.058 157.468 264.058 157.796V159.531H263.689V156.536H263.688Z",
    fill: "#1A66AB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M268.876 156.536H269.245V156.881L269.235 156.87V156.881H269.245C269.408 156.586 269.762 156.459 270.031 156.459C270.275 156.459 270.786 156.574 271.002 157.033C271.219 156.574 271.731 156.459 271.974 156.459C272.418 156.459 273.129 156.732 273.129 157.752V159.531H272.76V157.796C272.76 157.468 272.701 157.309 272.628 157.172C272.508 156.959 272.285 156.804 271.974 156.804C271.663 156.804 271.441 156.957 271.32 157.172C271.245 157.309 271.188 157.468 271.188 157.796V159.531H270.819V157.796C270.819 157.468 270.76 157.309 270.687 157.172C270.565 156.959 270.343 156.804 270.033 156.804C269.722 156.804 269.5 156.957 269.378 157.172C269.304 157.309 269.247 157.468 269.247 157.796V159.531H268.877V156.536H268.876Z",
    fill: "#1A66AB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M274.057 155.48H274.426V156.171H274.057V155.48ZM274.057 156.536H274.426V159.531H274.057V156.536Z",
    fill: "#1A66AB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M275.688 156.882H275.081V156.535H275.688V155.479H276.058V156.535H276.749V156.882H276.058V159.53H275.688V156.882Z",
    fill: "#1A66AB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M280.454 156.459C281.31 156.459 281.968 157.209 281.968 158.031C281.968 158.853 281.318 159.603 280.454 159.603C279.589 159.603 278.949 158.863 278.949 158.054C278.949 157.106 279.693 156.46 280.454 156.46M280.459 159.258C281.019 159.258 281.6 158.798 281.6 158.015C281.6 157.232 280.956 156.805 280.459 156.805C279.931 156.805 279.32 157.254 279.32 158.048C279.32 158.744 279.862 159.258 280.459 159.258Z",
    fill: "#1A66AB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M282.97 156.882H282.521V156.537H282.97C282.98 156.122 283.012 155.42 284.079 155.41V155.765C283.33 155.765 283.34 156.258 283.34 156.537H284.079V156.882H283.34V159.532H282.97V156.882Z",
    fill: "#1A66AB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M288.538 158.173C288.565 158.758 289.092 159.256 289.658 159.256C290.186 159.245 290.561 158.923 290.693 158.549H291.084C290.883 159.146 290.329 159.6 289.663 159.6C288.856 159.6 288.16 158.921 288.16 158.035C288.16 157.149 288.82 156.475 289.659 156.459C290.292 156.465 290.741 156.853 290.948 157.225C291.142 157.548 291.185 157.882 291.169 158.173H288.541H288.538ZM290.792 157.828C290.676 157.122 290.122 156.804 289.662 156.804C289.202 156.804 288.644 157.122 288.538 157.828H290.792Z",
    fill: "#1A66AB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M294.823 158.65C294.638 159.022 294.253 159.602 293.387 159.602C292.521 159.602 291.835 158.875 291.835 158.037C291.835 157.2 292.527 156.461 293.387 156.461C293.894 156.461 294.542 156.724 294.823 157.44H294.416C294.185 156.986 293.762 156.805 293.399 156.805C292.834 156.805 292.206 157.243 292.206 158.026C292.206 158.7 292.707 159.258 293.399 159.258C294 159.258 294.3 158.879 294.416 158.65H294.823Z",
    fill: "#1A66AB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M295.599 155.48H295.968V156.921H295.978C296.09 156.74 296.375 156.461 296.866 156.461C297.22 156.461 297.515 156.554 297.779 156.828C297.996 157.047 298.137 157.39 298.137 157.884V159.532H297.768V157.884C297.768 157.496 297.652 157.221 297.494 157.062C297.294 156.861 297.029 156.806 296.866 156.806C296.703 156.806 296.438 156.861 296.238 157.062C296.079 157.221 295.963 157.496 295.968 157.884V159.532H295.599V155.48Z",
    fill: "#1A66AB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M299.071 156.535H299.44V156.919H299.45C299.56 156.738 299.847 156.459 300.338 156.459C300.691 156.459 300.986 156.552 301.251 156.825C301.467 157.045 301.61 157.39 301.61 157.883V159.531H301.24V157.883C301.24 157.494 301.124 157.221 300.965 157.062C300.764 156.86 300.501 156.804 300.338 156.804C300.174 156.804 299.91 156.858 299.709 157.062C299.55 157.221 299.434 157.494 299.44 157.883V159.531H299.071V156.536V156.535Z",
    fill: "#1A66AB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M303.91 156.459C304.766 156.459 305.424 157.209 305.424 158.031C305.424 158.853 304.776 159.603 303.91 159.603C303.044 159.603 302.405 158.863 302.405 158.054C302.405 157.106 303.149 156.46 303.91 156.46M303.915 159.258C304.475 159.258 305.055 158.798 305.055 158.015C305.055 157.232 304.412 156.805 303.915 156.805C303.387 156.805 302.776 157.254 302.776 158.048C302.776 158.744 303.318 159.258 303.915 159.258Z",
    fill: "#1A66AB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M306.591 155.48H306.222V159.532H306.591V155.48Z",
    fill: "#1A66AB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M308.896 156.459C309.752 156.459 310.411 157.209 310.411 158.031C310.411 158.853 309.762 159.603 308.896 159.603C308.03 159.603 307.391 158.863 307.391 158.054C307.391 157.106 308.136 156.46 308.896 156.46M308.902 159.258C309.462 159.258 310.043 158.798 310.043 158.015C310.043 157.232 309.399 156.805 308.902 156.805C308.374 156.805 307.762 157.254 307.762 158.048C307.762 158.744 308.305 159.258 308.902 159.258Z",
    fill: "#1A66AB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M314.063 159.061C314.063 159.384 314.063 159.79 313.8 160.156C313.434 160.681 312.77 160.709 312.654 160.709C312.242 160.709 311.44 160.544 311.175 159.609H311.566C311.662 159.855 311.947 160.365 312.648 160.365C313.134 160.365 313.692 160.074 313.692 159.248V158.985H313.682C313.466 159.412 312.991 159.603 312.568 159.603C311.808 159.603 311.059 158.991 311.059 158.049C311.059 157.107 311.808 156.461 312.568 156.461C312.832 156.461 313.35 156.543 313.682 157.075H313.692V156.538H314.062V159.062L314.063 159.061ZM312.57 159.258C313.336 159.258 313.715 158.547 313.715 158.037C313.715 157.38 313.22 156.806 312.57 156.806C311.92 156.806 311.43 157.38 311.43 158.037C311.43 158.694 311.915 159.258 312.57 159.258Z",
    fill: "#1A66AB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M315.857 159.433L314.733 156.537H315.122L316.041 158.924L317.024 156.537H317.414L315.741 160.583H315.356L315.857 159.433Z",
    fill: "#1A66AB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M209.241 163.504L208.518 164.933L209.504 165.929L209.223 166.209L208.332 165.305C208.196 165.573 207.872 166.209 207.145 166.209C206.417 166.209 205.915 165.586 205.915 164.972C205.915 164.357 206.363 163.981 206.818 163.766C206.622 163.564 206.38 163.312 206.38 162.917C206.38 162.403 206.823 162.02 207.319 162.02C207.816 162.02 208.254 162.425 208.254 162.967C208.254 163.543 207.694 163.815 207.494 163.886L208.233 164.642L208.803 163.503H209.241V163.504ZM207.097 164.057C207.003 164.09 206.808 164.193 206.712 164.266C206.38 164.518 206.306 164.77 206.306 164.993C206.306 165.486 206.722 165.826 207.113 165.826C207.641 165.826 207.889 165.318 208.038 165.016L207.097 164.058V164.057ZM207.315 162.403C206.989 162.413 206.771 162.659 206.771 162.911C206.777 163.186 206.997 163.404 207.215 163.602C207.404 163.526 207.875 163.361 207.865 162.929C207.875 162.665 207.643 162.403 207.315 162.403Z",
    fill: "#1A66AB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M212.259 162.09H211.889V166.141H212.259V162.09Z",
    fill: "#1A66AB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M213.176 163.148H213.546V163.53H213.556C213.666 163.349 213.951 163.07 214.443 163.07C214.797 163.07 215.092 163.163 215.357 163.438C215.573 163.657 215.716 164.002 215.716 164.493V166.141H215.345V164.493C215.345 164.105 215.229 163.832 215.07 163.673C214.87 163.471 214.606 163.415 214.443 163.415C214.28 163.415 214.015 163.47 213.815 163.673C213.656 163.832 213.54 164.105 213.546 164.493V166.141H213.176V163.146V163.148Z",
    fill: "#1A66AB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M216.632 163.148H217.002V163.53H217.012C217.122 163.349 217.408 163.07 217.899 163.07C218.253 163.07 218.548 163.163 218.813 163.438C219.029 163.657 219.172 164.002 219.172 164.493V166.141H218.801V164.493C218.801 164.105 218.685 163.832 218.528 163.673C218.327 163.471 218.062 163.415 217.899 163.415C217.736 163.415 217.471 163.47 217.271 163.673C217.112 163.832 216.996 164.105 217.002 164.493V166.141H216.632V163.146V163.148Z",
    fill: "#1A66AB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M221.471 163.07C222.327 163.07 222.986 163.82 222.986 164.642C222.986 165.464 222.337 166.214 221.471 166.214C220.605 166.214 219.967 165.474 219.967 164.665C219.967 163.717 220.711 163.072 221.471 163.072M221.477 165.869C222.037 165.869 222.618 165.41 222.618 164.627C222.618 163.843 221.974 163.417 221.477 163.417C220.949 163.417 220.337 163.865 220.337 164.659C220.337 165.355 220.88 165.869 221.477 165.869Z",
    fill: "#1A66AB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M223.318 163.146H223.715L224.732 165.666L225.768 163.146H226.163L224.944 166.141H224.538L223.318 163.146Z",
    fill: "#1A66AB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M229.583 166.141H229.213V165.616H229.203C228.887 166.108 228.38 166.213 228.08 166.213C227.172 166.213 226.528 165.496 226.528 164.637C226.528 163.836 227.135 163.07 228.08 163.07C228.392 163.07 228.899 163.175 229.203 163.673H229.213V163.146H229.583V166.141ZM228.078 165.868C228.701 165.868 229.234 165.348 229.234 164.647C229.234 163.989 228.742 163.415 228.078 163.415C227.414 163.415 226.896 163.891 226.896 164.652C226.896 165.321 227.371 165.868 228.078 165.868Z",
    fill: "#1A66AB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M230.795 163.491H230.188V163.146H230.795V162.09H231.165V163.146H231.856V163.491H231.165V166.141H230.795V163.491Z",
    fill: "#1A66AB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M232.485 162.09H232.854V162.78H232.485V162.09ZM232.485 163.146H232.854V166.141H232.485V163.146Z",
    fill: "#1A66AB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M235.161 163.07C236.017 163.07 236.675 163.82 236.675 164.642C236.675 165.464 236.027 166.214 235.161 166.214C234.295 166.214 233.656 165.474 233.656 164.665C233.656 163.717 234.4 163.072 235.161 163.072M235.166 165.869C235.726 165.869 236.306 165.41 236.306 164.627C236.306 163.843 235.663 163.417 235.166 163.417C234.638 163.417 234.027 163.865 234.027 164.659C234.027 165.355 234.569 165.869 235.166 165.869Z",
    fill: "#1A66AB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M237.471 163.148H237.841V163.53H237.851C237.961 163.349 238.246 163.07 238.738 163.07C239.092 163.07 239.387 163.163 239.652 163.438C239.868 163.657 240.011 164.002 240.011 164.493V166.141H239.64V164.493C239.64 164.105 239.524 163.832 239.365 163.673C239.165 163.471 238.901 163.415 238.738 163.415C238.575 163.415 238.31 163.47 238.11 163.673C237.951 163.832 237.835 164.105 237.841 164.493V166.141H237.471V163.146V163.148Z",
    fill: "#1A66AB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M242.827 163.493H242.377V163.148H242.827C242.837 162.732 242.868 162.031 243.935 162.02V162.376C243.185 162.376 243.196 162.868 243.196 163.148H243.935V163.493H243.196V166.143H242.827V163.493Z",
    fill: "#1A66AB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M245.819 163.07C246.675 163.07 247.334 163.82 247.334 164.642C247.334 165.464 246.685 166.214 245.819 166.214C244.953 166.214 244.315 165.474 244.315 164.665C244.315 163.717 245.059 163.072 245.819 163.072M245.825 165.869C246.385 165.869 246.965 165.41 246.965 164.627C246.965 163.843 246.322 163.417 245.825 163.417C245.297 163.417 244.685 163.865 244.685 164.659C244.685 165.355 245.228 165.869 245.825 165.869Z",
    fill: "#1A66AB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M248.131 163.148H248.501V163.58H248.511C248.685 163.158 249.013 163.093 249.324 163.07V163.475C249.065 163.498 248.843 163.596 248.701 163.77C248.574 163.935 248.501 164.148 248.501 164.389V166.141H248.131V163.146V163.148Z",
    fill: "#1A66AB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M256.816 166.141H256.446V165.616H256.436C256.12 166.108 255.613 166.213 255.313 166.213C254.405 166.213 253.761 165.496 253.761 164.637C253.761 163.836 254.368 163.07 255.313 163.07C255.625 163.07 256.131 163.175 256.436 163.673H256.446V163.146H256.816V166.141ZM255.311 165.868C255.934 165.868 256.466 165.348 256.466 164.647C256.466 163.989 255.975 163.415 255.311 163.415C254.647 163.415 254.129 163.891 254.129 164.652C254.129 165.321 254.602 165.868 255.311 165.868Z",
    fill: "#1A66AB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M257.871 165.255C257.881 165.825 258.256 165.869 258.388 165.869C258.735 165.869 258.926 165.656 258.926 165.332C258.926 164.921 258.567 164.828 258.35 164.735C258.055 164.631 257.586 164.468 257.586 163.902C257.586 163.481 257.875 163.07 258.409 163.07C258.841 163.07 259.201 163.415 259.195 163.885H258.826C258.798 163.518 258.557 163.414 258.392 163.414C258.097 163.414 257.954 163.66 257.954 163.863C257.954 164.18 258.26 164.29 258.471 164.36C258.808 164.476 259.294 164.667 259.294 165.287C259.3 165.8 258.997 166.211 258.385 166.211C257.984 166.211 257.483 165.928 257.499 165.254H257.868L257.871 165.255Z",
    fill: "#1A66AB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M259.987 162.09H260.356V163.53H260.366C260.476 163.35 260.763 163.069 261.254 163.069C261.607 163.069 261.902 163.164 262.167 163.437C262.383 163.656 262.525 164.001 262.525 164.494V166.141H262.156V164.494C262.156 164.106 262.04 163.831 261.882 163.673C261.682 163.47 261.417 163.416 261.254 163.416C261.091 163.416 260.826 163.47 260.625 163.673C260.466 163.831 260.35 164.106 260.356 164.494V166.141H259.987V162.09Z",
    fill: "#1A66AB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M263.46 162.09H263.829V162.78H263.46V162.09ZM263.46 163.146H263.829V166.141H263.46V163.146Z",
    fill: "#1A66AB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M266.13 163.07C266.986 163.07 267.645 163.82 267.645 164.642C267.645 165.464 266.996 166.214 266.13 166.214C265.264 166.214 264.625 165.474 264.625 164.665C264.625 163.717 265.37 163.072 266.13 163.072M266.136 165.869C266.695 165.869 267.275 165.41 267.275 164.627C267.275 163.843 266.632 163.417 266.136 163.417C265.607 163.417 264.996 163.865 264.996 164.659C264.996 165.355 265.539 165.869 266.136 165.869Z",
    fill: "#1A66AB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M268.441 163.148H268.81V163.53H268.82C268.93 163.349 269.215 163.07 269.708 163.07C270.061 163.07 270.356 163.163 270.621 163.438C270.837 163.657 270.98 164.002 270.98 164.493V166.141H270.61V164.493C270.61 164.105 270.494 163.832 270.336 163.673C270.136 163.471 269.871 163.415 269.708 163.415C269.544 163.415 269.28 163.47 269.079 163.673C268.92 163.832 268.804 164.105 268.81 164.493V166.141H268.441V163.146V163.148Z",
    fill: "#1A66AB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 129,
    width: 13,
    height: 17
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M126.772 129.939V145.924H128.61V138.96H137.426V137.317H128.61V131.607H138.473V129.939H126.772Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.473 129.941H126.772V145.926H138.473V129.941Z",
    fill: "url(#paint2_linear_338_483)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 157,
    y: 129,
    width: 13,
    height: 18
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M157.806 134.072V134.119C157.806 136.747 159.528 137.932 163.272 138.731C166.692 139.438 167.507 140.283 167.507 141.769V141.813C167.507 143.389 166.065 144.53 163.877 144.53C161.69 144.53 159.991 143.777 158.293 142.27L157.152 143.594C159.107 145.308 161.225 146.152 163.806 146.152C167.04 146.152 169.366 144.372 169.366 141.633V141.587C169.366 139.143 167.691 137.842 164.062 137.066C160.48 136.313 159.643 135.468 159.643 133.961V133.913C159.643 132.475 160.993 131.334 163.107 131.334C164.784 131.334 166.296 131.859 167.807 133.069L168.878 131.676C167.228 130.374 165.528 129.713 163.156 129.713C160.061 129.713 157.804 131.563 157.804 134.074",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.368 129.713H157.153V146.152H169.368V129.713Z",
    fill: "url(#paint3_linear_338_483)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 129,
    width: 14,
    height: 17
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M184.35 129.939V137.042H174.951V129.939H173.113V145.924H174.951V138.731H184.35V145.924H186.188V129.939H184.35Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.187 129.941H173.113V145.926H186.187V129.941Z",
    fill: "url(#paint4_linear_338_483)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 190,
    y: 129,
    width: 3,
    height: 17
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M192.794 129.943H190.957V145.926H192.794V129.943Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.794 129.943H190.957V145.926H192.794V129.943Z",
    fill: "url(#paint5_linear_338_483)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 129,
    width: 18,
    height: 18
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M198.749 137.931V137.887C198.749 134.256 201.401 131.332 205.123 131.332C208.845 131.332 211.544 134.3 211.544 137.931V137.977C211.544 141.607 208.891 144.529 205.17 144.529C201.45 144.529 198.749 141.562 198.749 137.931ZM196.843 137.931V137.977C196.843 142.383 200.17 146.197 205.125 146.197C210.08 146.197 213.453 142.339 213.453 137.931V137.887C213.453 133.48 210.125 129.666 205.17 129.666C200.215 129.666 196.843 133.526 196.843 137.931Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.453 129.666H196.843V146.197H213.453V129.666Z",
    fill: "url(#paint6_linear_338_483)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 217,
    y: 129,
    width: 15,
    height: 17
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M229.318 129.939V142.751L219.059 129.939H217.338V145.924H219.128V132.818L229.643 145.924H231.109V129.939H229.318Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.109 129.941H217.338V145.926H231.109V129.941Z",
    fill: "url(#paint7_linear_338_483)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 234,
    y: 129,
    width: 18,
    height: 18
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M236.903 137.931V137.887C236.903 134.256 239.554 131.332 243.277 131.332C246.999 131.332 249.696 134.3 249.696 137.931V137.977C249.696 141.607 247.043 144.529 243.322 144.529C239.602 144.529 236.901 141.562 236.901 137.931M234.992 137.931V137.977C234.992 142.383 238.32 146.197 243.275 146.197C248.23 146.197 251.603 142.339 251.603 137.931V137.887C251.603 133.48 248.276 129.666 243.321 129.666C238.366 129.666 234.99 133.526 234.99 137.931",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.606 129.666H234.993V146.197H251.606V129.666Z",
    fill: "url(#paint8_linear_338_483)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 255,
    y: 129,
    width: 12,
    height: 17
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M255.49 129.939V145.924H266.495V144.257H257.327V129.939H255.49Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.495 129.941H255.49V145.926H266.495V129.941Z",
    fill: "url(#paint9_linear_338_483)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 268,
    y: 129,
    width: 17,
    height: 18
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M270.147 137.931V137.887C270.147 134.256 272.799 131.332 276.521 131.332C280.243 131.332 282.942 134.3 282.942 137.931V137.977C282.942 141.607 280.289 144.529 276.567 144.529C272.844 144.529 270.147 141.562 270.147 137.931ZM268.237 137.931V137.977C268.237 142.383 271.564 146.197 276.521 146.197C281.477 146.197 284.849 142.339 284.849 137.931V137.887C284.849 133.48 281.523 129.666 276.567 129.666C271.61 129.666 268.237 133.526 268.237 137.931Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.849 129.666H268.237V146.197H284.849V129.666Z",
    fill: "url(#paint10_linear_338_483)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 288,
    y: 129,
    width: 15,
    height: 18
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M288.011 137.93V137.976C288.011 142.543 291.177 146.197 296.295 146.197C299.039 146.197 301.32 145.079 302.833 143.753V137.384H296.11V139.003H301.064V142.977C299.947 143.867 298.225 144.573 296.363 144.573C292.411 144.573 289.921 141.743 289.921 137.929V137.885C289.921 134.323 292.504 131.33 296.11 131.33C298.412 131.33 299.809 132.084 301.064 133.157L302.25 131.787C300.621 130.44 298.923 129.664 296.177 129.664C291.293 129.664 288.011 133.547 288.011 137.929",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.832 129.666H288.011V146.197H302.832V129.666Z",
    fill: "url(#paint11_linear_338_483)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 304,
    y: 129,
    width: 16,
    height: 17
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M317.861 129.939L312.323 137.931L306.833 129.939H304.6L311.37 139.599V145.924H313.231V139.576L320 129.939H317.861Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320 129.941H304.6V145.926H320V129.941Z",
    fill: "url(#paint12_linear_338_483)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 129,
    width: 10,
    height: 17
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M146.198 129.828L138.776 145.924H140.66L147.919 129.828H146.198Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.919 129.828H138.776V145.924H147.919V129.828Z",
    fill: "url(#paint13_linear_338_483)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 129,
    width: 10,
    height: 17
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M146.162 129.885L153.421 145.982H155.305L147.885 129.885H146.162Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.305 129.885H146.162V145.982H155.305V129.885Z",
    fill: "url(#paint14_linear_338_483)"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M126.772 111H131.064C132.275 111 133.233 111.336 133.817 111.961C134.251 112.424 134.49 113.049 134.49 113.817V113.849C134.49 115.226 133.667 116.201 132.471 116.49C133.907 116.714 135.044 117.77 135.044 119.276V119.308C135.044 121.148 133.667 122.206 131.303 122.206H126.772V111ZM131.303 116.38C132.858 116.38 134.161 115.578 134.161 113.866V113.833C134.161 112.313 133.008 111.321 131.05 111.321H127.101V116.38H131.303ZM131.303 121.888C133.458 121.888 134.715 120.943 134.715 119.326V119.295C134.715 117.597 133.279 116.701 131.559 116.701H127.101V121.888H131.303Z",
    fill: "#010101"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M149.087 111H149.371L157.328 121.63V111H157.643V122.207H157.358L149.401 111.577V122.207H149.087V111Z",
    fill: "#010101"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M160.288 116.635V116.604C160.288 113.61 162.277 110.809 165.464 110.809C167.064 110.809 168.051 111.323 169.099 112.249L168.89 112.521C167.916 111.673 166.944 111.128 165.449 111.128C162.503 111.128 160.619 113.818 160.619 116.587V116.62C160.619 119.533 162.413 122.079 165.465 122.079C167.02 122.079 168.306 121.343 169.189 120.542V116.94H165.329V116.587H169.518V120.67C168.532 121.63 167.139 122.399 165.449 122.399C162.172 122.399 160.29 119.758 160.29 116.635",
    fill: "#010101"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M172.404 111H172.732V121.888H179.165V122.207H172.404V111Z",
    fill: "#010101"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M185.176 110.918H185.461L190.502 122.204H190.144L188.648 118.842H181.978L180.48 122.204H180.137L185.176 110.918ZM188.498 118.521L185.311 111.38L182.125 118.521H188.498Z",
    fill: "#010101"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M192.611 111H195.976C199.266 111 201.54 113.434 201.54 116.588V116.621C201.54 119.773 199.268 122.207 195.976 122.207H192.611V111ZM195.991 121.886C199.072 121.886 201.211 119.564 201.211 116.635V116.603C201.211 113.657 199.056 111.321 195.961 111.321H192.94V121.886H195.991Z",
    fill: "#010101"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M204.187 111H211.5V111.321H204.516V116.412H210.857V116.732H204.516V121.888H211.576V122.207H204.187V111Z",
    fill: "#010101"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M213.325 120.572L213.564 120.317C214.625 121.421 215.972 122.045 217.497 122.045C219.458 122.045 220.714 120.908 220.714 119.403V119.371C220.714 117.993 219.935 117.259 217.289 116.682C214.701 116.121 213.715 115.305 213.715 113.736V113.704C213.715 112.136 215.151 110.838 217.125 110.838C218.502 110.838 219.728 111.335 220.685 112.119L220.475 112.407C219.547 111.655 218.382 111.159 217.095 111.159C215.255 111.159 214.042 112.374 214.042 113.688V113.72C214.042 115.08 214.851 115.801 217.424 116.361C220.146 116.954 221.043 117.834 221.043 119.355V119.386C221.043 121.051 219.683 122.364 217.468 122.364C215.869 122.364 214.448 121.708 213.327 120.57",
    fill: "#010101"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M223.6 111H223.929V116.396H231.408V111H231.738V122.207H231.408V116.717H223.929V122.207H223.6V111Z",
    fill: "#010101"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M136.613 122.205L141.653 110.918H141.937L146.978 122.205H146.62L141.787 111.383L136.955 122.205H136.613Z",
    fill: "#010101"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M127.71 164.177L127.963 163.909C129.093 165.062 130.523 165.713 132.144 165.713C134.227 165.713 135.561 164.528 135.561 162.957V162.923C135.561 161.487 134.735 160.718 131.922 160.118C129.171 159.533 128.122 158.681 128.122 157.043V157.009C128.122 155.372 129.648 154.02 131.746 154.02C133.207 154.02 134.512 154.536 135.528 155.355L135.305 155.656C134.32 154.87 133.08 154.353 131.713 154.353C129.758 154.353 128.47 155.623 128.47 156.993V157.027C128.47 158.446 129.328 159.199 132.062 159.783C134.955 160.402 135.909 161.321 135.909 162.907V162.942C135.909 164.678 134.461 166.048 132.109 166.048C130.408 166.048 128.898 165.362 127.707 164.177",
    fill: "#010101"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M138.453 160.701V154.186H138.802V160.701C138.802 164.06 140.503 165.73 142.967 165.73C145.431 165.73 147.1 164.06 147.1 160.718V154.187H147.449V160.702C147.449 164.277 145.637 166.065 142.951 166.065C140.265 166.065 138.453 164.296 138.453 160.702",
    fill: "#010101"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M150.58 154.188H150.914L155.763 161.437L160.61 154.188H160.928V165.881H160.579V154.805L155.763 162.023H155.747L150.93 154.805V165.881H150.58V154.188Z",
    fill: "#010101"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M164.234 154.188H164.567L169.415 161.437L174.263 154.188H174.582V165.881H174.233V154.805L169.415 162.023H169.399L164.583 154.805V165.881H164.234V154.188Z",
    fill: "#010101"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M178.347 154.188H177.998V165.881H178.347V154.188Z",
    fill: "#010101"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M184.562 154.521H180.54V154.188H188.934V154.521H184.911V165.881H184.562V154.521Z",
    fill: "#010101"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M194.331 165.867L193.722 165.871L201.434 154.068H202.041L194.331 165.867Z",
    fill: "#1B65AA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 123,
    width: 26,
    height: 66
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0015 123.975L76.6916 185.926L85.2987 188.433L69.1168 126.42L60.0029 123.975H60.0015Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.7971 118.006L44.7754 127.801L61.4946 194.412L100.516 184.618L83.7971 118.006Z",
    fill: "url(#paint15_linear_338_483)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 112,
    width: 24,
    height: 77
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0981 126.457L85.2987 188.434L92.57 181.168L78.3452 128.91L85.4647 121.847L83.0395 112.348L69.0981 126.457Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.2568 100.898L31.9816 158.742L83.4084 199.884L129.684 142.04L78.2568 100.898Z",
    fill: "url(#paint16_linear_338_483)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 110,
    width: 28,
    height: 50
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0933 131.503L95.535 159.602L115.94 139.082L113.484 129.808L99.9287 143.378L97.4319 133.958L111.002 120.44L108.494 110.984L88.0933 131.503Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.6259 102.99L74.1361 155.193L113.417 167.601L129.907 115.398L90.6259 102.99Z",
    fill: "url(#paint17_linear_338_483)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 112,
    width: 10,
    height: 10
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0037 112.346L85.4647 121.846L92.5127 114.888L83.0037 112.346Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.8709 107.671L78.333 117.977L88.64 126.515L97.1778 116.209L86.8709 107.671Z",
    fill: "url(#paint18_linear_338_483)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_338_483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 127,
    width: 17,
    height: 17
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4319 133.958L99.9287 143.378L113.484 129.808L104.1 127.328L97.4319 133.958Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_338_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.124 120.567L90.6724 139.68L109.786 150.131L120.237 131.018L101.124 120.567Z",
    fill: "url(#paint19_linear_338_483)"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M251.882 162.08H253.597V162.478H252.207V163.616H253.496V164.014H252.207V166.142H251.882V162.08Z",
    fill: "#1A66AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_338_483",
    x1: 68.8391,
    y1: 154.102,
    x2: 88.5445,
    y2: 148.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#173863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#154F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#13619B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#116EAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1176B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1075B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#106BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#104273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#10244C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_338_483",
    x1: 101.454,
    y1: 133.68,
    x2: 116.163,
    y2: 129.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#173863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#154F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#13619B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#116EAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1176B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1075B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#106BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#104273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#10244C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_338_483",
    x1: 133.926,
    y1: 139.825,
    x2: 133.926,
    y2: 105.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_338_483",
    x1: 163.863,
    y1: 143.473,
    x2: 163.863,
    y2: 108.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_338_483",
    x1: 180.994,
    y1: -90104.6,
    x2: 180.994,
    y2: -90111.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_338_483",
    x1: 193.644,
    y1: 137.571,
    x2: 193.644,
    y2: 102.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_338_483",
    x1: 203.37,
    y1: 154.999,
    x2: 203.37,
    y2: 120.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_338_483",
    x1: 225.527,
    y1: -90104.6,
    x2: 225.527,
    y2: -90111.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_338_483",
    x1: 241.535,
    y1: 154.999,
    x2: 241.535,
    y2: 120.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_338_483",
    x1: 262.308,
    y1: -90104.6,
    x2: 262.308,
    y2: -90111.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_338_483",
    x1: 274.755,
    y1: 154.999,
    x2: 274.755,
    y2: 120.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_338_483",
    x1: 293.67,
    y1: 154.999,
    x2: 293.67,
    y2: 120.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_338_483",
    x1: 313.616,
    y1: -90104.6,
    x2: 313.616,
    y2: -90111.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_338_483",
    x1: 143.828,
    y1: 143.803,
    x2: 143.828,
    y2: 109.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_338_483",
    x1: 150.393,
    y1: 148.013,
    x2: 150.393,
    y2: 113.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_338_483",
    x1: 68.28,
    y1: 132.802,
    x2: 83.4626,
    y2: 193.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#145083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#1266A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1174B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1074B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#1067A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#105187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#10335F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_338_483",
    x1: 71.3456,
    y1: 164.272,
    x2: 92.3353,
    y2: 138.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#145083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#1266A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1174B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1074B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#1067A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#105187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#10335F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_338_483",
    x1: 91.7081,
    y1: 131.919,
    x2: 111.646,
    y2: 138.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#164473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#135B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#126BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#1175B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#1073B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#1065A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#104D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#102C57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_338_483",
    x1: 83.0723,
    y1: 113.66,
    x2: 92.2563,
    y2: 121.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#145083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#1266A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1174B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1074B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#1067A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#105187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#10335F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_338_483",
    x1: 105.073,
    y1: 134.257,
    x2: 113.427,
    y2: 118.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#173863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#154F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#13619B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#116EAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1176B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1179BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1075B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#106BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#105A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#104273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#10244C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101D43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 89.3565,
    fill: "white",
    transform: "translate(60 105)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfse);
export default __webpack_public_path__ + "static/media/bfse.b2cec96ec890182f02cc0245505c219c.svg";
export { ForwardRef as ReactComponent };